import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import { Role, SchoolCandidateRemarkType } from "../models";
import { User } from "../models/User/User";

interface Remark {
  id: number;
  schoolCandidateId: number;
  schoolCandidateRemarkTypeId: number;
  remark: string;
  dateCreated: string;
  dateUpdated: string | null;
  createdById: User["id"];
  appUserId: User["id"]; // This is the user that updated the remark
  role: Role;
}

interface SaveRemarkRequest {
  id?: number;
  schoolCandidateId: number;
  schoolCandidateRemarkTypeId: number;
  remark: string;
}

export const remarkApi = createApi({
  reducerPath: "remarkApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Remarks"],
  endpoints: (build) => ({
    getRemarkTypes: build.query<SchoolCandidateRemarkType[], void>({
      query: () => "school-candidates/remark-types",
    }),
    getRemarks: build.query<Remark[], number>({
      query: (schoolCandidateId) =>
        `school-candidates/remarks/${schoolCandidateId}/${SchoolCandidateRemarkType.GeneralRemark}`,
      providesTags: ["Remarks"],
    }),
    saveRemark: build.mutation<void, SaveRemarkRequest>({
      query: (data) => ({
        url: "school-candidates/save-remark",
        method: "post",
        data,
      }),
      invalidatesTags: ["Remarks"],
    }),
    updateRemark: build.mutation<void, SaveRemarkRequest>({
      query: (data) => ({
        url: "school-candidates/update-remark",
        method: "put",
        data,
      }),
      invalidatesTags: ["Remarks"],
    }),
    deleteRemark: build.mutation<void, number>({
      query: (remarkId) => ({
        url: `school-candidates/delete-remark/${remarkId}`,
        method: "delete",
      }),
      invalidatesTags: ["Remarks"],
    }),
  }),
});

export const {
  useGetRemarkTypesQuery,
  useGetRemarksQuery,
  useSaveRemarkMutation,
  useUpdateRemarkMutation,
  useDeleteRemarkMutation,
} = remarkApi;
